
type ScreenType =
  | 'intro'
  | 'factoid'
  | 'info'
  | 'feedback'
;

export const backgrounds = [
	'bursting-bubbles',
	'circle-conveyor',
	'circular-orbits',
	'drifting-bubbles',
	'fast-bubbles',
	'popcorn-circles',
	'rapid-rebounds',
	'ricochets-and-rings',
	'slow-pulse',
	'soft-pendulums',
] as const;
export type Background = typeof backgrounds[number];

interface Illustration {
	id: string
	name: string
	layout: 'Top' | 'Bottom'
	url: string
}

export interface ScreenConfig {
	id: string
	type: ScreenType
	bg?: Background
	props?: object
}

export interface FactoidConfig extends ScreenConfig {
	type: 'factoid'
	illustration: Illustration
	text: string
}

export interface IntroConfig extends ScreenConfig {
	type: 'intro'
}

interface FeedbackConfig extends ScreenConfig {
	type: 'feedback'
}

type KnownConfig =
  | FactoidConfig
  | IntroConfig
  | FeedbackConfig;

export interface Reel {
  id: string;
  screens: KnownConfig[];
}
